<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="progress_bar overflow-x-auto p-8">
    <div class="progress_bar__body" :class="checkPointItem.length > 3 ? 'progress_bar__inline-flex' : 'progress_bar__flex'">
      <div
        v-for="(item, index) in checkPointItem"
        :key="index"
        class="progress_bar__progress-wrapper progress_bar__flex-item"
        :style="index === 0 && 'width: max-content;'"
        data-testid="progress-wrapper"
      >
        <BlProgressBarAv v-if="index > 0" :percentage="item.percentage" class="w-full mt-4" />
        <div class="relative">
          <div v-if="index > 0" class="progress-bar__checkpoint-wrapper" :style="isMweb ? 'left: -20px;' : 'left: -24px;'">
            <div
              class="progress-bar__icon-wrapper"
              :class="isAvailableQuota(item) ? 'progress-bar__icon-wrapper-active' : 'progress-bar__icon-wrapper-disable'"
              data-testid="icon-wrapper"
            >
              <IcoGiftMinor :color="isAvailableQuota(item) ? '#FAB801' : '#B6B6B6'" class="flex" data-testid="progress-icon" />
            </div>
            <BlTextAv variation="body-14" weight="bold" class="w-max">Misi ke-{{ index }}</BlTextAv>
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.75593 5.12713C5.35716 5.58759 4.64284 5.58759 4.24407 5.12713L1.23682 1.65465C0.675944 1.00701 1.136 0 1.99275 0L8.00725 0C8.864 0 9.32406 1.00701 8.76318 1.65465L5.75593 5.12713Z"
                fill="#fab801"
              />
            </svg>
          </div>
          <BlRadioAv class="progress-bar__radio" native-value="true" :value="index === 0 || item.percentage >= 100" />
          <BlTextAv
            variation="caption-10"
            class="progress_bar__checkpoint-text"
            :style="index > 0 && 'left: -100%'"
            data-testid="checkpoint-text"
            v-html="item.text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {IcoGiftMinor} from '@bukalapak/bazaar-visual-next';
import {BlTextAv, BlRadioAv, BlProgressBarAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaProgressBar',
  components: {
    IcoGiftMinor,
    BlTextAv,
    BlRadioAv,
    BlProgressBarAv,
  },
  props: {
    checkPointItem: {
      type: Array,
      default: () => {
        return [];
      },
      validator: (checkpoints) => {
        return checkpoints && checkpoints.every((checkpoint) => Number.isFinite(checkpoint.percentage));
      },
    },
  },
  computed: {
    isMweb() {
      return window.location.hostname.startsWith('m.');
    },
  },
  methods: {
    isAvailableQuota(item) {
      return item.used_quota < item.quota;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress_bar {
  min-height: 136px;
  .progress_bar__body {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
  .progress_bar__flex {
    display: flex;
    max-width: 94%;
    .progress_bar__flex-item {
      width: 100%;
    }
  }
  .progress_bar__inline-flex {
    display: inline-flex;
  }
  .progress_bar__progress-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    width: 148px;
    margin-top: 64px;
  }
  .progress_bar__checkpoint-text {
    position: absolute;
    width: max-content;
    text-align: center;
    margin-top: 4px;
  }
  .progress-bar__radio::v-deep {
    pointer-events: none;
    p {
      display: none;
    }
  }
  .progress-bar__checkpoint-wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: -60px;
  }
  .progress-bar__icon-wrapper {
    padding: 7px;
    aspect-ratio: 1;
    clip-path: polygon(100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%, 25% 6.7%, 75% 6.7%);
  }
  .progress-bar__icon-wrapper-active {
    background: #fff2e0;
  }
  .progress-bar__icon-wrapper-disable {
    background: #f2f2f2;
  }
}
</style>
